import { useMemo } from 'react';
import { getChildAccentTheme } from '../shared/childAccentTheme';

const useMobileActiveChild = ({ activeChildId, allEntries, children }) => {
  const activeChild = useMemo(
    () => children.find((child) => child.id === activeChildId) || children[0] || null,
    [activeChildId, children]
  );

  const activeChildAccent = useMemo(
    () => getChildAccentTheme(activeChild || {}, { children }),
    [activeChild, children]
  );

  const activeChildEntries = useMemo(
    () => allEntries[activeChild?.id] || [],
    [allEntries, activeChild?.id]
  );

  return {
    activeChild,
    activeChildAccent,
    activeChildEntries,
  };
};

export default useMobileActiveChild;
